module.exports = __webpack_public_path__ + "img/home-gif.8aae7656.gif";